/**
 * focus-source.js — records whether the visitor is using a pointer or the Tab key.
 *
 * Sets data-focus-source="pointer" or "keyboard" on <html>. CSS reads it to keep the
 * focus ring off a text field that was clicked or tapped.
 *
 * WHY CSS ALONE CANNOT DO THIS
 * :focus-visible skips mouse clicks on buttons and links, but browsers match it on a
 * text field however the field got focus, mouse included. So on a text field the
 * :focus-visible ring shows on every click.
 *
 * ONLY TAB COUNTS AS KEYBOARD
 * Typing must not flip the value: someone who clicked into a field and is typing in it
 * would get the ring back mid-word.
 *
 * NO ATTRIBUTE MEANS SHOW THE RING
 * Before the first press, and for focus moved by assistive technology, the attribute is
 * missing or not "pointer". Write the CSS so the ring shows in that case:
 *   html:not([data-focus-source="pointer"]) .field:focus-visible { outline: … }
 */
(function () {
  const root = document.documentElement;

  // Capture phase, so a stopPropagation() further down cannot hide the event.
  document.addEventListener(
    'pointerdown',
    () => {
      root.dataset.focusSource = 'pointer';
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Tab') root.dataset.focusSource = 'keyboard';
    },
    true
  );
})();
